var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.25C0 2.38805 0.34241 1.5614 0.951903 0.951903C1.5614 0.34241 2.38805 0 3.25 0H16.75C17.1768 0 17.5994 0.0840637 17.9937 0.247391C18.388 0.410719 18.7463 0.650112 19.0481 0.951903C19.3499 1.25369 19.5893 1.61197 19.7526 2.00628C19.9159 2.40059 20 2.8232 20 3.25V14.75C20 15.1768 19.9159 15.5994 19.7526 15.9937C19.5893 16.388 19.3499 16.7463 19.0481 17.0481C18.7463 17.3499 18.388 17.5893 17.9937 17.7526C17.5994 17.9159 17.1768 18 16.75 18H3.25C2.38805 18 1.5614 17.6576 0.951903 17.0481C0.34241 16.4386 0 15.612 0 14.75V3.25ZM7.5 6.384V11.615C7.5 12.185 8.11 12.547 8.61 12.273L13.396 9.657C13.5141 9.59241 13.6126 9.49724 13.6812 9.38147C13.7499 9.2657 13.7861 9.13359 13.7861 8.999C13.7861 8.86441 13.7499 8.7323 13.6812 8.61653C13.6126 8.50076 13.5141 8.40559 13.396 8.341L8.61 5.726C8.49578 5.6635 8.36726 5.63182 8.23708 5.63406C8.1069 5.63631 7.97955 5.6724 7.86755 5.73879C7.75555 5.80518 7.66277 5.89958 7.59832 6.01271C7.53388 6.12584 7.49999 6.2538 7.5 6.384Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.428271a6672f48172188d384248c1fdd.svg";
export { ForwardRef as ReactComponent };